import _ from 'lodash';
import {
  useState,
  useEffect,
} from 'react';
import {
  bigqueryGetUserLogsRowCount,
} from '../../services/api-v1-services/other-services';

const getUserLogsRowsCount = () => {
  const [ userLogsRowsCountData, setUserLogsRowsCountData ] = useState({ });
  const [ fetchData, setFetchData ] = useState(null);
  const {
    requestData,
    onOperationComplete,
  } = fetchData || {};

  const fetchUserLogsRowCount = async () => {
    try {
      console.log(`Fetching user logs rows data...`);
      setUserLogsRowsCountData({
        isFetching: true,
        isError: false,
      });

      const apiResp =  await bigqueryGetUserLogsRowCount(requestData);

      const responseData = apiResp.data;
      let errorMsg = null;
      if(responseData.success) {
        console.log(`Fetching user logs rows data Success!!`);
      } else {
        console.log(`Fetching user logs rows data Failed!!`);
        errorMsg = `Error occurred while fetching user logs rows data.`;
      }

      setUserLogsRowsCountData({
        data: responseData.data,
        isFetching: false,
        isError: !responseData.success,
        errorMsg,
      });

      if(onOperationComplete) {
        onOperationComplete({
          isError: !responseData.success,
          errorMsg,
          data: responseData.data,
        });
      }

    } catch (err) {
      const errorMsg = (err.response && err.response.status === 422) ?
        `Can't process due to invalid data!` : `Error occurred while fetching user logs rows data.`;
      console.log(`${errorMsg} Error : ${err}`);
      setUserLogsRowsCountData({
        data: null,
        isFetching: false,
        isError: true,
        errorMsg,
      });

      if(onOperationComplete) {
        onOperationComplete({
          isError: true,
          errorMsg,
          data: null,
        });
      }
    }
  };

  useEffect( () => {
    if(!_.isEmpty(fetchData)) {
      fetchUserLogsRowCount();
    }
  }, [ fetchData ]);

  return [
    userLogsRowsCountData,
    setFetchData,
    setUserLogsRowsCountData,
  ];
};

export default getUserLogsRowsCount;
